"use client";

import { c as _c } from "react/compiler-runtime";
import { classNames, FlexCenter, TextBody, Tooltip, tv } from "@opensea/ui-kit";
import { useTranslations } from "next-intl";
import { useSubscriptionStatus } from "@/hooks/use-subscription/use-subscription-status";
const indicatorVariants = tv({
  base: "size-2 rounded-full",
  variants: {
    status: {
      live: "bg-success-1",
      paused: "bg-warning",
      degraded: "bg-error-1"
    }
  }
});
export function SubscriptionLiveIndicator() {
  const $ = _c(26);
  const t = useTranslations("SubscriptionLiveIndicator");
  const result = useSubscriptionStatus();
  let t0;
  if ($[0] !== result || $[1] !== t) {
    t0 = function getStatusText() {
      if (!result) {
        return "";
      }
      switch (result.status) {
        case "paused":
          {
            return t("paused");
          }
        case "degraded":
          {
            return t("degraded");
          }
        default:
          {
            return t("live");
          }
      }
    };
    $[0] = result;
    $[1] = t;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const getStatusText = t0;
  let t1;
  if ($[3] !== getStatusText) {
    t1 = getStatusText();
    $[3] = getStatusText;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const statusText = t1;
  let t2;
  if ($[5] !== result || $[6] !== t) {
    t2 = function getTooltipText() {
      if (!result || result.status !== "degraded") {
        return "";
      }
      return result.reason === "offline" ? t("offlineError") : t("unknownError");
    };
    $[5] = result;
    $[6] = t;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const getTooltipText = t2;
  if (!result) {
    return null;
  }
  let t3;
  if ($[8] !== result.status) {
    t3 = classNames(indicatorVariants({
      status: result.status
    }), "absolute inline-flex size-full animate-ping opacity-75");
    $[8] = result.status;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t3) {
    t4 = <span className={t3} />;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== result.status) {
    t5 = classNames(indicatorVariants({
      status: result.status
    }), "relative inline-flex size-2");
    $[12] = result.status;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t5) {
    t6 = <span className={t5} />;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t4 || $[17] !== t6) {
    t7 = <span className="relative flex size-2">{t4}{t6}</span>;
    $[16] = t4;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== getTooltipText || $[20] !== result.status || $[21] !== statusText) {
    t8 = result.status === "degraded" ? <Tooltip content={getTooltipText()}><TextBody size="xs">{statusText}</TextBody></Tooltip> : <TextBody size="xs">{statusText}</TextBody>;
    $[19] = getTooltipText;
    $[20] = result.status;
    $[21] = statusText;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== t7 || $[24] !== t8) {
    t9 = <FlexCenter className="gap-2">{t7}{t8}</FlexCenter>;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  return t9;
}